// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1nq7q","modalFooterButton":"ModalNotes_modalFooterButton__m0PG1"};